export enum SOCKET_KEY_ADS {
    get = 'getAds',
    view = 'viewAds',
    byId = 'getAdsById',
    add = 'AddAdsRequest',
}